(() => {
  class MedicalAccessoryCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('.med-accessory-grid');
      this.controls = this.querySelector('.med-extras-arrows');
      if (!this.track || !this.controls) return;
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.controls.hidden = false;
      this.controls.addEventListener('click', event => {
        const button = event.target.closest('[data-extras-direction]');
        if (button && !button.disabled) this.move(Number(button.dataset.extrasDirection));
      }, {signal});
      this.addEventListener('keydown', event => {
        if (event.target !== this.track && !event.target.closest('[data-extras-direction]')) return;
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({left:event.key === 'Home' ? 0 : this.track.scrollWidth, behavior:this.motion()});
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, {signal});
      this.track.addEventListener('scroll', () => this.update(), {passive:true,signal});
      window.addEventListener('resize', () => this.update(), {signal});
      if (typeof ResizeObserver !== 'undefined') {
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
      }
      this.update();
    }
    motion() { return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
    move(direction) {
      const card = this.track.querySelector('.med-accessory-card');
      const gap = parseFloat(getComputedStyle(this.track).gap) || 12;
      const step = (card?.getBoundingClientRect().width || this.track.clientWidth) + gap;
      this.track.scrollBy({left:direction * step, behavior:this.motion()});
    }
    update() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const previous = this.controls.querySelector('[data-extras-direction="-1"]');
      const next = this.controls.querySelector('[data-extras-direction="1"]');
      previous.disabled = previous.hidden = this.track.scrollLeft <= 1;
      next.disabled = next.hidden = this.track.scrollLeft >= max - 1;
      this.controls.hidden = max <= 1;
      const focused = document.activeElement;
      if ((focused === previous && previous.hidden) || (focused === next && next.hidden)) {
        const target = !next.hidden ? next : !previous.hidden ? previous : this.track;
        target.focus({preventScroll:true});
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  }
  if (!customElements.get('med-accessory-carousel')) customElements.define('med-accessory-carousel', MedicalAccessoryCarousel);
})();
